import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from "react";
import { apiClient } from "@/api/ApiClient";
const ApiClientContext = createContext(null);
export const ApiClientProvider = ({ children, }) => {
    return (_jsx(ApiClientContext.Provider, { value: apiClient, children: children }));
};
export const useApiClient = () => {
    const context = useContext(ApiClientContext);
    if (!context) {
        throw new Error("useApiClient must be used within an ApiClientProvider");
    }
    return context;
};
